import React from 'react';
import BioCardRender, {BioCardProps} from './BioCardRender';

export const BioCard=({...props}:BioCardProps):JSX.Element=>{

	return <BioCardRender
		{...props}
	/>;
};
